export const KKP_VENTE_WIZARD_STEPS = [
  { id: 'vente', title: 'Vente' },
  { id: 'brief', title: 'Brief créatif' },
];

export const BRIEF_CREATIF_GUIDANCE = [
  { question: "Quel est l'objectif de l'encart ?", example: 'générer des leads, notoriété locale…' },
  { question: "Quelle est la cible principale de l'encart ?", example: 'artisans BTP, particuliers 35-55 ans…' },
  { question: 'Quelle offre doit-on mettre en avant ?', example: '-20% sur la gamme été, devis gratuit…' },
  { question: 'Quelle est la promesse ?', example: 'intervention sous 24h, expertise depuis 1985…' },
  { question: 'Textes à faire figurer, mentions légales…', example: 'slogan exact, logo obligatoire…' },
];

const LEGACY_FIELD_LABELS = {
  objectif: 'Objectif',
  cible: 'Cible principale',
  offre: 'Offre',
  promesse: 'Promesse',
  precisions: 'Précisions',
};

function mergeLegacyBrief(briefEncart) {
  const parts = [];
  Object.entries(LEGACY_FIELD_LABELS).forEach(([key, label]) => {
    const value = String(briefEncart[key] ?? '').trim();
    if (value) {
      parts.push(`${label} : ${value}`);
    }
  });

  return parts.join('\n\n');
}

export function venteBriefFromApi(briefEncart) {
  if (!briefEncart || typeof briefEncart !== 'object') {
    return '';
  }

  const creatif = String(briefEncart.brief_creatif ?? '').trim();
  if (creatif) {
    return creatif;
  }

  return mergeLegacyBrief(briefEncart);
}

export function briefCreatifToPayload(briefCreatif) {
  const trimmed = String(briefCreatif ?? '').trim();

  return trimmed ? { brief_creatif: trimmed } : null;
}

export function isBriefComplete(briefEncart) {
  return venteBriefFromApi(briefEncart).trim() !== '';
}

export function isVenduOk(statutPhase) {
  const normalized = String(statutPhase ?? '').trim();
  return normalized === 'Vendu OK' || normalized === 'Elem OK';
}

export function suggestBriefWizardStep(vente, initialWizardStep) {
  if (typeof initialWizardStep === 'number') {
    return initialWizardStep;
  }
  if (vente?.brief_incomplete) {
    return 1;
  }
  return 0;
}

/** @returns {'incomplete'|'complete'|null} */
export function getVenteBriefStatus(vente) {
  if (!isVenduOk(vente?.statut_phase)) {
    return null;
  }
  if (vente?.brief_incomplete) {
    return 'incomplete';
  }
  return 'complete';
}

export function briefStatusWizardStep(vente, status) {
  if (status === 'incomplete') {
    return suggestBriefWizardStep(vente);
  }
  if (status === 'complete') {
    return 1;
  }
  return 0;
}
